"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.Title = exports.StyledVillain = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const typography_1 = __importDefault(require("../typography"));
const PREFIX = "Villain";
exports.classes = {
    reversed: `${PREFIX}-reversed`,
    container: `${PREFIX}-container`,
    content: `${PREFIX}-content`,
    image: `${PREFIX}-image`,
    text: `${PREFIX}-text`,
    cta: `${PREFIX}-cta`,
    contained: `${PREFIX}-contained`,
    fullSize: `${PREFIX}-fullSize`,
    media: `${PREFIX}-media`
};
exports.StyledVillain = (0, styles_1.styled)("div")(({ theme }) => ({
    minHeight: "auto",
    color: theme.colours.white,
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    "& + &": {
        marginTop: "24px"
    },
    [`&.${exports.classes.reversed}`]: {
        flexDirection: "column-reverse"
    },
    [`.${exports.classes.container}`]: {
        height: "100%",
        display: "flex",
        flexDirection: "column"
    },
    [`.${exports.classes.content}`]: {
        padding: "60px 0",
        marginTop: "auto",
        marginBottom: "auto",
        [theme.breakpoints.up(769)]: {
            minHeight: "320px"
        }
    },
    [`.${exports.classes.image}`]: {
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        width: "100%",
        height: "500px",
        overflow: "hidden",
        "&::after": {
            content: "''",
            display: "block",
            paddingTop: "100%"
        },
        [theme.breakpoints.up(769)]: {
            position: "absolute !important",
            top: 0,
            left: "50%",
            width: "50vw",
            height: "100%",
            maxHeight: "none",
            "&::after": {
                paddingTop: 0
            }
        }
    },
    [`.${exports.classes.cta}`]: {
        marginTop: "32px"
    },
    [`&.${exports.classes.contained}`]: {
        [`.${exports.classes.content}`]: {
            padding: "60px 30px",
            height: "100%",
            [theme.breakpoints.up(769)]: {
                width: "auto"
            },
            [theme.breakpoints.up("lg")]: {
                paddingRight: "60px",
                paddingLeft: "60px"
            }
        },
        [`.${exports.classes.text}`]: {
            fontSize: "1rem"
        },
        [`.${exports.classes.image}`]: {
            [theme.breakpoints.up(769)]: {
                position: "relative !important",
                width: "100%",
                height: "100%",
                left: 0
            }
        }
    },
    [`&.${exports.classes.fullSize}`]: {
        [`.${exports.classes.content}`]: {
            [theme.breakpoints.up(769)]: {
                width: "50%",
                paddingRight: "60px",
                marginTop: "auto",
                marginBottom: "auto"
            }
        },
        [`&.${exports.classes.reversed}`]: {
            [`.${exports.classes.content}`]: {
                [theme.breakpoints.up(769)]: {
                    marginLeft: "50%",
                    paddingRight: 0,
                    paddingLeft: "60px"
                }
            },
            [`.${exports.classes.image}`]: {
                [theme.breakpoints.up(769)]: {
                    left: "auto",
                    right: "50%"
                }
            }
        }
    }
}));
exports.Title = (0, styles_1.styled)(typography_1.default)({
    "&::after": {
        // NOTE: Fix the next slide being visible
        marginLeft: "1px"
    }
});
exports.Text = (0, styles_1.styled)("div")(({ theme }) => ({
    width: "100%",
    maxWidth: "566px",
    fontSize: "1.22rem",
    [theme.breakpoints.up(769)]: {
        width: "100%"
    }
}));
//# sourceMappingURL=data:application/json;base64,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